import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { stringify } from 'hub-http/helpers/params';
import { MB_POST_MESSAGE_TYPE, IFRAME_ID, PickerTypes } from '../constants';
let _iframeOriginOverride = null;
export function _overrideIframeAppOrigin(origin) {
  _iframeOriginOverride = origin;
}
export function getIframeAppOrigin(location = window.location) {
  if (_iframeOriginOverride) {
    return _iframeOriginOverride;
  }
  let hubletOverride;
  const hostnameParts = location.hostname.split('.');
  const subdomain = hostnameParts[hostnameParts.length - 2];
  if (subdomain.includes('-')) {
    hubletOverride = subdomain.split('-')[1];
  }
  if (enviro.getShort(IFRAME_ID) === 'local') {
    return getFullUrl('local', {
      hubletOverride
    });
  }
  return getFullUrl('app', {
    hubletOverride
  });
}
const PATHS_BY_PICKER_TYPE = {
  [PickerTypes.MEDIA_BRIDGE]: 'media-bridge-iframe-ui',
  [PickerTypes.HUBSPOT_VIDEO]: 'video-picker',
  [PickerTypes.DIGITAL_ASSET]: 'digital-assets-picker'
};
export const getIframeUrl = pickerType => {
  const appPath = PATHS_BY_PICKER_TYPE[pickerType] || PATHS_BY_PICKER_TYPE[PickerTypes.MEDIA_BRIDGE];
  const params = {
    topOrigin: window.location.origin,
    hostApp: getCurrentApp()
  };
  return `${getIframeAppOrigin()}/${appPath}/${PortalIdParser.get()}?${stringify(params)}`;
};
export function getVideoThumbnailUrl(videoId) {
  return `${getFullUrl('app-api')}/video/v1/public/${videoId}/thumbnail?portalId=${PortalIdParser.get()}`;
}
export const isMbIframeMessage = event => {
  return event.data && typeof event.data === 'object' && event.data.type === MB_POST_MESSAGE_TYPE;
};
export const isDebug = () => enviro.debug('media_bridge');
export const logDebug = (...args) => {
  if (isDebug()) {
    console.log('[media-bridge]', ...args);
  }
};
export function getCurrentApp() {
  const {
    hubspot
  } = window;
  return hubspot && hubspot.bender && hubspot.bender.currentProject;
}
let tempId = 1;
export const uniqueId = () => {
  return tempId++;
};

// firing a global FileManagerLib:Drawer:open event allows apps work around a Chrome bug
// that prevents drag and drop events to the file manager drawer if it is on top of an iframe.
// More info in https://git.hubteam.com/HubSpot/FileManagerUI/pull/1272
export function fireEvent(type) {
  let event;
  try {
    event = new CustomEvent(type);
  } catch (e) {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(type, false, false, null);
  }
  document.dispatchEvent(event);
}